import * as _ from 'lodash';

import { Observable, BehaviorSubject } from 'rxjs';

import { Tag, TagType } from 'src/app/people/models/tag';
import { map, publishLast, refCount } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/shared/services/base.service';
import { PersonDetailsService } from './person-details.service';

@Injectable()
export class TagService extends BaseService {
  private _tags: BehaviorSubject<Tag[]> = new BehaviorSubject<Tag[]>([]);

  public readonly tags: Observable<Tag[]> = this._tags.asObservable();

  constructor(personDetailsService: PersonDetailsService) {
    super();

    personDetailsService.personUpdated.subscribe((person) => {
      this.getTags();
    });
  }

  getTags(): Observable<Tag[]> {
    let obs = this.get(this.tagsBaseUrl())
      .pipe(map(this.convertTagsData))
      .pipe(publishLast())
      .pipe(refCount());

    obs.subscribe((tags) => {
      this._tags.next(tags);
    });

    return obs;
  }

  deleteTag(tagId: string): Observable<any> {
    return this.delete(this.tagsBaseUrl().concat(`/${tagId}`));
  }

  createTag(tag: Tag) {
    let tagStream = JSON.stringify(tag);
    return this.post(this.tagsBaseUrl(), tagStream).pipe(
      map((tag) => {
        return new Tag(tag);
      })
    );
  }

  getTagList(): Observable<Tag[]> {
    return this.get(this.tagsBaseUrl()).pipe(map(this.convertTagsData));
  }

  private tagsBaseUrl() {
    return 'tags';
  }

  private convertTagsData(data) {
    return _.map(data, function (tag) {
      return new Tag(tag);
    });
  }
}
